import { FC } from "react";
import { BaseColumnProps } from "../BaseColumnProps";
import { ColumnElementConstructor } from "../ColumnElementConstructor";

/**
 * The `VirtualColumn` component properties.
 */

export interface VirtualColumnProps extends BaseColumnProps {}

/**
 * Column which acts as a virtual column.
 */
export const VirtualColumn: FC<VirtualColumnProps> = () => {
  return null;
};

(VirtualColumn as ColumnElementConstructor<VirtualColumnProps>).className = "virtual-column";
